import styled from "styled-components";
import { ModalContainer } from "../../../components/Modal/styled";

export const CreateFromAppModalContainer = styled(ModalContainer)`
  overflow: visible;
`;
